'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (dataURI) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'customDynamicFile.pdf';
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var blob = new Blob([ab], {
    type: mimeString
  });
  return new File([blob], name, {
    type: mimeString
  });
};